export function jsonFromPrismaBytes(data: any): any {
    if (data == null) {
        return null;
    }

    if (Buffer.isBuffer(data)) {
        // todo: remove once Prisma 6 migration is baked
        return JSON.parse(data.toString());
    } else if (data instanceof Uint8Array) {
        return JSON.parse(new TextDecoder().decode(data));
    }

    return data;
}
